import { resolveURL } from "../utils/url.js";
async function fetchSession(baseURL) {
  const url = resolveURL("/api/v4/session/", baseURL);
  const response = await fetch(url, { credentials: "include" });
  const data = await response.json().catch();
  if (!response.ok || !data) {
    return {
      is_logged_in: false
    };
  }
  return data;
}
export {
  fetchSession
};
